<template>
    <div class="footer">
        <div class="footer__bottom">
            <div class="footer__logo">
                <a href="/" class="footer__logo--link">
                    <img src="/img/logo.png" alt="HealthNow Logo">
                    <p class="footer__title txt--blue">{{ $recipient }}</p>
                </a>
            </div>
            <div class="footer__links">
                <a href="/frequently-asked-questions">FREQUENTLY ASKED QUESTIONS</a>
                <a href="/terms-and-conditions" v-show="$launch">TERMS AND CONDITIONS</a>
                <a href="/privacy-policy">PRIVACY POLICY</a>
                <a :href="`mailto:${$contact}`" target="_blank">CONTACT US</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'FooterHome',
};
</script>
